export default "/storefront/client/images/Leadership.png";